<template>
  <div class="pregled-vsebine">
    <div class="postavitev-izbirnika">
      <div class="izbirnik-stranke">
        <div>
          <IzbirnikStranke v-on:osvezitevIzbranihPodatkovStranke="GetStranka" :selectorPermissions="selectorPermissions" />
        </div>
      </div>
    </div>
    <div style="clear: both"/>
    <div class="vsebina-postavitev">
      <div class="odmik-vsebine">
        <div>
          <p class="open-sans-30pt">
            Internet
          </p>
          <div v-if="seznamNosilnihPrikljuckov.length !== 0">
            <div v-if="seznamNosilnihPrikljuckov.length > 1" style="padding-top: 20px">
              <p>
                Izbrani priključek
                  <IzbirnikPrikljuckaSelect
                    style-class="izbirnik-prikljuckov"
                    @novIzbranPrikljucek="izbranPrikljucek = $event"
                    :izbranPrikljucek="izbranPrikljucek"
                    :seznamPrikljuckovGrupirano="seznamPrikljuckovGrupirano"
                  />
              </p>
            </div>
            <div style="padding-top: 15px">
              <el-tabs type="border-card" @tab-click="HandleTabClick" :value="tabsValue">
                <el-tab-pane label="Samostojne hitrosti" name="t1" ref="t1" v-if="samostojneHitrosti">
                  <div v-if="activetab === 't1'">
                    <SamostojneHitrosti :izbranPrikljucek="izbranPrikljucek"
                                        :seznamHitrosti="seznamHitrosti"
                                        :izbranaStrankaInfo="izbranaStrankaInfo"
                                        :nalaganjePaketov="nalaganjePaketov"
                                        v-on:osveziPakete="PridobiSamostojneHitrosti"/>
                  </div>
                </el-tab-pane>
                <el-tab-pane label="Wifi" name="t2" ref="t2">
                  <div v-if="activetab === 't2'">
                    <Wifi :izbranPrikljucek="izbranPrikljucek"
                          :seznamWifi="seznamWifi"/>
                  </div>
                </el-tab-pane>
              </el-tabs>
            </div>
          </div>
          <div v-if="seznamNosilnihPrikljuckov.length === 0 && !pridobivanjePodatkov">
            <div class="obvestilo-prazen-seznam">
              <p>
                Nimate priključka, ki bi omogočil naročilo.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import Vue from 'vue'
import IzbirnikStranke from '../GlobalneKomponente/IzbirnikStranke.vue'
import {PridobivanjeVklopljenoNaroceno} from 'src/assets/js/globalne_funkcije/NarociTelevizija/GetNarocenoVklopljeno.js'
import {StoritevVrstaEnum} from '../../../../assets/js/Enum/StoritevVrstaEnum.js'
import Wifi from '../../../Dashboard/Views/Naroci/NarociInternet/Wifi.vue'
import SamostojneHitrosti from '../../../Dashboard/Views/Naroci/NarociInternet/SamostojneHitrosti.vue'
import ZascitaVarnostna from '../../../Dashboard/Views/Naroci/NarociInternet/ZascitaVarnostna.vue'
import {SirinaOkna} from 'src/assets/js/globalne_funkcije/SirinaOkna.js'
import {Checkbox, Button, Option, Select, Pagination, TabPane, Tabs} from 'element-ui'
import {StringConverter} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/StringConverter'
import ClientAgent from '../../../../assets/js/clientAgent.js'
import {SeznamVrednosti} from '../../../../assets/js/globalne_funkcije/SplosneGlobalneFunkcije/SeznamVrednosti'
import {GetPodatkiIzbirnika} from 'src/assets/js/globalne_funkcije/SplosneGlobalneFunkcije/GetPodatkiIzbirnika.js'
import IzbirnikPrikljuckov from '../GlobalneKomponente/IzbirnikPrikljuckov'
import {UrejenSeznamPrikljuckov} from '../../../../assets/js/globalne_funkcije/UrejenSeznamPrikljuckov'
import IzbirnikPrikljuckaSelect from '../GlobalneKomponente/IzbirnikPrikljuckaSelect.vue'

export default {
  name: 'NarociInternet',
  mixins: [
    SirinaOkna,
    StoritevVrstaEnum,
    PridobivanjeVklopljenoNaroceno,
    GetPodatkiIzbirnika,
    StringConverter,
    SeznamVrednosti
  ],
  data () {
    return {
      activetab: 't1',
      clientAgent: null,
      seznamWifi: [],
      seznamNaroceneHitrosti: [],
      seznamVklopljeneHitrosti: [],
      seznamMoznihStoritev: [],
      seznamHitrosti: [],
      nalaganjePaketov: false,
      seznamNarocenaZascita: [],
      seznamVkloplenaZascita: [],
      izbranPrikljucek: null,
      izbranaStranka: '',
      podatkiStranke: [],
      izbranSap: '',
      seznamNosilnihPrikljuckov: [],
      idStranka: '',
      samostojneHitrosti: false,
      tabsValue: 't1',
      nalaganjeVsebine: true,
      selectorPermissions: ['STRANKE'],
      pridobivanjePodatkov: true,
      izbranaStrankaInfo: null,
      seznamPrikljuckovGrupirano: []
    }
  },
  mounted () {
    this.clientAgent = new ClientAgent()
    this.$nextTick(function () {
      window.addEventListener('resize', this.SirinaOknaPresegaVrednostTabela)
    })
    this.PridobiSamostojneHitrosti()
  },
  watch: {
    orientacijaPrikazaTabele: function (val) {
      this.prikazTabele = val
    },
    izbranPrikljucek: function () {
      if (this.izbranPrikljucek !== null) {
        this.PridobiSamostojneHitrosti()
      }
    }
  },
  components: {
    IzbirnikPrikljuckaSelect,
    'Wifi': Wifi,
    'IzbirnikStranke': IzbirnikStranke,
    'SamostojneHitrosti': SamostojneHitrosti,
    'ZascitaVarnostna': ZascitaVarnostna,
    'IzbirnikPrikljuckov': IzbirnikPrikljuckov,
    [Checkbox.name]: Checkbox,
    [Button.name]: Button,
    [Option.name]: Option,
    [Select.name]: Select,
    [Pagination.name]: Pagination,
    [TabPane.name]: TabPane,
    [Tabs.name]: Tabs
  },
  methods: {
    GetStranka (podatkiStranke) {
      if (podatkiStranke !== null) {
        this.izbranaStrankaInfo = null
        this.izbranaStranka = podatkiStranke.id_stranka
        this.GetPrikljuckiDovoljenja(this.izbranaStranka)
        this.izbranaStrankaInfo = podatkiStranke
      }
    },
    GetPrikljuckiDovoljenja (prenosniParamIdStranka) {
      if (prenosniParamIdStranka !== '') {
        this.izbranaStranka = prenosniParamIdStranka
        let param = ['permissionId=PRIKLJUCKI']
        param.push('filter[tip_prikljucka]=FIX')
        this.clientAgent.postWsRequest(
          this,
          'permissions/havePermission',
          param,
          null,
          'SetPrikljuckiDovoljenja',
          'ErrPrikljuckiDovoljenja')
      }
    },
    SetPrikljuckiDovoljenja (podatki) {
      this.tabsValue = ''
      this.activetab = ''
      this.seznamPrikljuckovGrupirano = []
      this.seznamNosilnihPrikljuckov = []
      this.izbranPrikljucek = ''
      UrejenSeznamPrikljuckov.methods.UrediSeznam(
        this,
        this.izbranaStranka,
        podatki.permission.additionalData
      )
    },
    GetUrejenSeznamPrikljuckov (list, groupedList, izbranPrikljucek) {
      this.seznamNosilnihPrikljuckov = list
      this.izbranPrikljucek = izbranPrikljucek !== undefined ? izbranPrikljucek.id_prikljucek : list[0].id_prikljucek
      this.seznamPrikljuckovGrupirano = groupedList
      this.pridobivanjePodatkov = false
    },
    async PridobiSamostojneHitrosti () {
      if (this.izbranPrikljucek !== '' && this.izbranPrikljucek !== null) {
        let response = await this.clientAgent.makeRequest(
          'prikljucek/storitve/getNaborSamostojnihHitrosti?',
          {
            idPrikljucek: this.izbranPrikljucek
          },
          'GET'
        ).catch((e) => this.ErrSeznamSamostojnihHitrosti(e))
        this.SetSeznamHitrosti(response)
      }
    },
    ErrSeznamSamostojnihHitrosti (e) {
    },
    SetSeznamHitrosti (response) {
      this.tabsValue = ''
      this.activetab = ''
      this.samostojneHitrosti = false
      this.seznamHitrosti = []
      if (typeof response !== 'undefined' && typeof response.data !== 'undefined' && response.data.length > 0) {
        for (let i = 0; i < response.data.length; i++) {
          Vue.set(response.data[i], 'naroceno', 0)
          Vue.set(response.data[i], 'vklopljeno', 0)
          if (response.data[i].naziv !== 'brez interneta' && response.data[i].prikazServisne === 1) {
            this.seznamHitrosti.push(response.data[i])
          }
        }
        this.samostojneHitrosti = true
        this.tabsValue = 't1'
        this.activetab = 't1'
        this.PridobivanjeVklopljenoNaroceno()
      } else {
        this.samostojneHitrosti = false
        this.tabsValue = 't2'
        this.activetab = 't2'
      }
    },
    PridobivanjeVklopljenoNaroceno () {
      let param = {}
      param.vmesnik = this
      param.prenesenIzbranId = this.izbranPrikljucek
      let seznamIskanihStoritev = [StoritevVrstaEnum.NAJEM_PROGRAMSKE_OPREME]
      param.idVrsta = [].concat(seznamIskanihStoritev, this.GetVrsteStoritveInternet())
      param.idStatusVklopljeno = 1
      param.idStatusNaroceno = 0
      this.GetNaroceneStoritve(param)
      this.GetVklopljeneStoritve(param)
    },
    HandleTabClick (tab) {
      this.activetab = ''
      this.activetab = tab.name
    },
    SetSeznamVkloplenihStoritev (prenParametri, seznamVklopljenih) {
      this.seznamVklopljenih = []
      this.seznamVklopljenih = seznamVklopljenih
      if (this.seznamVklopljenih !== 0) {
        for (let i = 0; i < this.seznamVklopljenih.length; i++) {
          if (typeof this.seznamHitrosti !== 'undefined') {
            for (let j = 0; j < this.seznamHitrosti.length; j++) {
              if (this.seznamHitrosti[j].idStoritevVrstaIzbira === this.seznamVklopljenih[i].idStoritev) {
                Vue.set(this.seznamHitrosti[j], 'vklopljeno', 1)
                Vue.set(this.seznamHitrosti[j], 'datumVklopa', this.seznamVklopljenih[i].trajanjeOd)
              }
            }
          }
        }
      }
    },
    SetSeznamNarocenihStoritev (prenParametri, seznamNarocenih) {
      this.seznamNarocenih = []
      this.seznamNarocenih = seznamNarocenih
      if (this.seznamNarocenih !== 0) {
        for (let i = 0; i < this.seznamNarocenih.length; i++) {
          if (typeof this.seznamHitrosti !== 'undefined') {
            for (let j = 0; j < this.seznamHitrosti.length; j++) {
              if (this.seznamHitrosti[j].idStoritevVrstaIzbira === this.seznamNarocenih[i].idStoritev) {
                Vue.set(this.seznamHitrosti[j], 'naroceno', 1)
              }
            }
          }
        }
      }
    }
  }
}
</script>
<style scoped src="../../../../../static/css/MojT-2/T2Klub/T2Klub.css">
</style>






// WEBPACK FOOTER //
// src/components/Dashboard/Views/Naroci/NarociInternet.vue